import baseConstants from './constants.base'

const constants = {
  ...baseConstants,
  backendHost: process.env.REACT_APP_SIMPLESAT_API_URL || 'http://localhost:8000',
  surveyHost: `https://${process.env.REACT_APP_SIMPLESAT_SURVEY_URL || 'survey-dev.simplesat.io'}`,
  intercomAppID: 'ignphdk6',
  dropboxClientId: 'o2343jvp7z3sby1',
  sentryDSN: undefined,
  sentryTracesSampleRate: 0.0,
  stripeApiKey: process.env.REACT_APP_STRIPE_API_KEY,
  intercomAppClientId:
    process.env.REACT_APP_INTERCOM_APP_CLIENT_ID || '41ee2a61-d728-434b-9f81-5abfe9fadeb9',
  webEmbedScriptURL:
    process.env.REACT_APP_EMBED_SCRIPT_URL ||
    'https://cdn-dev.simplesat.io/web-embed/web-embed-loader.js',
  webEmbedPreviewSurveyToken:
    process.env.REACT_APP_WEB_EMBED_PREVIEW_SURVEY_TOKEN ||
    '6T5BddI_u2HRpqvtKKGFIyrXbNaQcmoFE96Mlgr8BzU',
  workOsClientId: process.env.REACT_APP_WORKOS_CLIENT_ID || 'client_01H5HH2JQHKDPB45HXYKQHDC2N',
  demoHostname: process.env.REACT_APP_DEMO_HOSTNAME || 'dev-demo.simplesat.io',
  demoUserId: process.env.REACT_APP_DEMO_USER_ID || '189',
  widgetPresets: {
    carouselPresetsUrl:
      process.env.REACT_APP_WIDGET_CAROUSEL_PRESETS ||
      'https://cdn-dev.simplesat.io/config/carouselPresets.json',
    gridPresetsUrl:
      process.env.REACT_APP_WIDGET_GRID_PRESETS ||
      'https://cdn-dev.simplesat.io/config/gridPresets.json',
    masonryPresetsUrl:
      process.env.REACT_APP_WIDGET_MASONRY_PRESETS ||
      'https://cdn-dev.simplesat.io/config/masonryPresets.json',
    popupBoxPresetsUrl:
      process.env.REACT_APP_WIDGET_POPUP_BOX_PRESETS ||
      'https://cdn-dev.simplesat.io/config/popupBoxPresets.json',
    scorePresetsUrl:
      process.env.REACT_APP_WIDGET_SCORE_PRESETS ||
      'https://cdn-dev.simplesat.io/config/scorePresets.json',
  },
  onboardingPreviewSurveyUrl:
    process.env.REACT_APP_ONBOARDING_PREVIEW_SURVEY_URL ||
    'https://survey-dev.simplesat.io/?init=eyJwcmV2aWV3IjogInRydWUiLCAiY2xpZW50X2VtYWlsIjogInRlc3RlckBleGFtcGxlLmNvbSIsICJzdXJ2ZXlfZXhwaXJlZCI6IGZhbHNlLCAic3VydmV5X2V4cGlyZWRfZGF0ZSI6ICIiLCAiYXV0aG9yX2lkIjogbnVsbCwgImNvbXBhbnlfaWQiOiAyLCAic3VydmV5X3Rva2VuIjogIkFranVMTEN3WGJYejByeTlTWmE0UWc4ZTZwVEFrRXM2N0dRZTJyMlhhR0kiLCAidGlja2V0X2lkIjogInN0UExVTVdOeU5ZIiwgImFzc2lnbmVlIjogbnVsbCwgInN1cnZleV90eXBlIjogImdlbmVyaWNfZW1iZWQiLCAicmVsYXRlZF9mZWVkYmFja19ldmVudF9pZCI6IG51bGwsICJ2YWx1ZSI6IG51bGwsICJjdXJyZW50X3N0ZXAiOiAwLCAidXNlX2V4cGVyaW1lbnRfZmVhdHVyZSI6IHRydWUsICJlbWFpbF9ldmVudCI6IG51bGwsICJpc19tdWx0aWxpbmd1YWxfc3VydmV5X2VuYWJsZWQiOiBmYWxzZX0=&preview=true',
}

export default constants



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/config/constants.dev.js